import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import * as moment from 'moment';

import { OrderHistoryLine } from '../../models/orderhistoryline';
import { OrderHistory } from '../../models/orderhistory';

import { CartProduct } from '../../../cart/models/cart-models';

@Component({
  selector: 'app-orderhistorylines-page',
  templateUrl: './orderhistorylines-page.component.html',
  styleUrls: ['./orderhistorylines-page.component.scss']
})
export class OrderhistorylinesPageComponent  {
  @Input() orderHistoryItem: OrderHistory
  @Input() orderHistoryLines: OrderHistoryLine[]
  @Input() loading: boolean
  @Input() expanding: boolean
  @Input() cartProducts: {[product: string]: CartProduct}
  @Input() reOrderableProductCodes: string[]
  @Input() currency: string

  @Output() onExpand = new EventEmitter<void>()
  @Output() onReOrder = new EventEmitter<string>()

  constructor(private location: Location) {

  }


  get getCartProducts(): string {
    return JSON.stringify(this.cartProducts);
  }

  get requestedDeliveryDate(): string {
    if (this.orderHistoryItem && this.orderHistoryItem.dlvDate && moment(this.orderHistoryItem.dlvDate).isValid()) {
      return moment(this.orderHistoryItem.dlvDate).format('DD-MM-YYYY')
    }
  }

  goBack() {
    this.location.back()
  }

  expand() {
    this.onExpand.emit()
  }

  reOrder(productId: string): void {
    this.onReOrder.emit(productId)
  }

  isInCart(line: OrderHistoryLine): boolean
  {
    if (line.currentProduct && line.currentProduct.length > 0)
    {
      const productId = line.currentProduct[0]._id;
      const product = this.cartProducts[productId];
      return !!product;
    }
    return false;
  }

  isReOrderable(line: OrderHistoryLine): boolean {
    if (line && line.productCode) {
      return this.reOrderableProductCodes.indexOf(line.productCode) >= 0;
    }
    return false;
  }

}
